(function () {
  const bbmQtys = {};

  const PLAN_IDS = {
    mensal: 10828120342,
  };

  window["bbmQty"] = function (bid, delta) {
    bbmQtys[bid] = Math.max(1, (bbmQtys[bid] || 1) + delta);
    document.getElementById("bbm-qty-" + bid).textContent = bbmQtys[bid];
  };

  window["bbmAddToCart"] = function (bid, variantId, planId, available) {
    if (!available) return;

    const btn = document.getElementById("bbm-add-" + bid);
    btn.disabled = true;
    btn.textContent = "Adicionando...";

    const qty = bbmQtys[bid] || 1;

    const sellingPlanId =
      typeof planId === "string" ? PLAN_IDS[planId] : planId;

    if (!sellingPlanId) {
      alert("Erro: plano de assinatura inválido");
      btn.disabled = false;
      btn.textContent = "Adicionar ao carrinho";
      return;
    }

    const payload = {
    items: [
        {
        id: variantId,
        quantity: qty,
        selling_plan: sellingPlanId,
        },
    ],
    };

    console.log("=================================");
    console.log("[BBM DEBUG] PAYLOAD ENVIADO:");
    console.log(JSON.stringify(payload, null, 2));
    console.log("Variant ID:", variantId);
    console.log("Quantity:", qty);
    console.log("Selling Plan ID:", sellingPlanId);
    console.log("=================================");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: qty,
            selling_plan: sellingPlanId,
          },
        ],
      }),
    })
            .then(async (r) => {
        const text = await r.text();

        console.log("=================================");
        console.log("[BBM DEBUG] RESPONSE RAW:");
        console.log(text);
        console.log("Status HTTP:", r.status);
        console.log("=================================");

        if (!r.ok) {
            throw new Error(text);
        }

        return JSON.parse(text);
        })
      .then((data) => {
        console.log("Sucesso:", data);

        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );

        //window.location.href = "/cart";
      })
      .catch((err) => {
        console.error("Erro real:", err);

        alert(err.description || err.message || "Erro ao adicionar");

        btn.disabled = false;
        btn.textContent = "Adicionar ao carrinho";
      });
  };
})();